const mixin = {
  data() {
    return {
      eduBackgroundMap: {
        1: '初中',
        2: '高中 ',
        3: '专科 ',
        4: '本科 ',
        5: '研究生 '
      },
      teacherKindMap: {
        1: '全职',
        2: '兼职',
        3: '劳动合同制',
        4: '其它'
      },
      pscLevelMap: {
        1: '一级甲等',
        2: '一级乙等 ',
        3: '二级甲等 ',
        4: '二级乙等 ',
        5: '三级甲等 ',
        6: '三级乙等 '
      },
      ncreLevelMap: {
        1: '一级',
        2: '二级 ',
        3: '三级 ',
        4: '四级 '
      }
    }
  },
  methods: {
    getGenderStr(val) {
      const map = {
        0: '未知',
        1: '男',
        2: '女'
      }
      return map[Number(val)]
    },
    getTeacherKindStr(val) {
      const map = {
        0: '--',
        ...this.teacherKindMap
      }
      return map[Number(val)]
    },
    getTeacherTypeStr(val) {
      const map = {
        0: '--',
        1: '校内',
        2: '校外'
      }
      return map[Number(val)]
    },
    getDduBackgroundStr(val) {
      const map = {
        0: '--',
        ...this.eduBackgroundMap
      }
      return map[Number(val)]
    },
    getNcreLevelStr(val) {
      const map = {
        0: '--',
        ...this.ncreLevelMap
      }
      return map[Number(val)]
    },
    getPscLevelStr(val) {
      const map = {
        0: '--',
        ...this.pscLevelMap
      }
      return map[Number(val)]
    }
  }
}

export default mixin
